export const checkAccess = (checks: boolean[]): boolean => {
  return checks.every(Boolean);
};
